import { Form } from 'antd'
import { useEffect, useState } from 'react'
import WizrInput from '../WizrInput'
import WizrTextArea from '../WizrTextArea'
import WizrFlexSpacing from '../WizrFlexSpacing'
import WizrButton from '../WizrButton'
import WizrFlexLayout from '../WizrFlexLayout'
import { styled } from 'styled-components'



const StyledContainer = styled(WizrFlexLayout)`
  gap: 8px;
`

interface ICustomField {
  fieldName?: string
  fieldDescription?: string
  onSubmit: (params: { [key: string]: any }) => void
  onCancel: () => void
  onSave: (params: { [key: string]: any }) => void
}

const CustomField = ({
  fieldName,
  fieldDescription,
  onCancel,
  onSave,
  onSubmit
}: ICustomField): JSX.Element => {
  const [form] = Form.useForm()
 

  // State to store field name and description
  const [name, setName] = useState(fieldName || '')
  const [description, setDescription] = useState(fieldDescription || '')
  const [showFieldNameValidation, setShowFieldNameValidation] = useState(false)

  useEffect(() => {
    form.setFieldValue('fieldName', fieldName)
    form.setFieldValue('fieldDescription', fieldDescription)
  }, [fieldName, fieldDescription])

  const isBlank = (text?: string) => !text || text.trim() === ''

  const handleSave = async () => {
    try {
      const values = await form.validateFields()
      if (isBlank(values.fieldName)) {
        setShowFieldNameValidation(true)
        return
      }
      setShowFieldNameValidation(false)
      onSave({ name: values.fieldName, description: values.fieldDescription || description })
    } catch (error) {
      return
    }
  }

  return (
    <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <Form
        name='customField'
        form={form}
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        onFinishFailed={() => null}
        autoComplete='off'
      >
        <Form.Item
          name='fieldName'
          style={{ textAlign: 'left' }}
        >
          <WizrInput
            background='#F2F4F9'
            placeholder='Enter Field Name'
            required={true}
            showError={showFieldNameValidation}
            errorMessage="Please enter a valid field name"
            onChange={(value: string) => {
              form.setFieldsValue({ fieldName: value })
              setName(value)
              if (showFieldNameValidation && !isBlank(value)) {
                setShowFieldNameValidation(false)
              }
            }}
            style={{ textAlign: 'left' }}
          />
        </Form.Item>
        <Form.Item
          name='fieldDescription'
        >
          <WizrTextArea
            background='#F2F4F9'
            placeholder='Enter Field Description'
            onChange={(value: string) => setDescription(value)}
          />
        </Form.Item>
       
        <Form.Item>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type='default' text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
            <WizrButton text={'Save'} onClick={handleSave} style={{borderRadius: '20px'}}/>
          </WizrFlexSpacing>
        </Form.Item>
      </Form>
    </StyledContainer>
  )
}

export default CustomField 